[
    {
        "id": "apply-availability",
        "title": "Applying Availability",
        "videoLink": "",
        "markdownFile": "apply-availability.md",
        "icon": "pi pi-calendar"
    },
    {
        "id": "areas",
        "title": "Areas",
        "videoLink": "",
        "markdownFile": "areas.md",
        "icon": "pi pi-map-marker"
    },
    {
        "id": "availability-schedule",
        "title": "Availability Schedule",
        "videoLink": "",
        "markdownFile": "availability-schedule.md",
        "icon": "pi pi-calendar-times"
    },
    {
        "id": "cancel-job",
        "title": "Canceling a Job",
        "videoLink": "",
        "markdownFile": "cancel-job.md",
        "icon": "pi pi-ban"
    },
    {
        "id": "create-area",
        "title": "Creating an Area",
        "videoLink": "",
        "markdownFile": "create-area.md",
        "icon": "pi pi-plus"
    },
    {
        "id": "create-asset",
        "title": "Creating Assets",
        "videoLink": "",
        "markdownFile": "create-asset.md",
        "icon": "pi pi-plus"
    },
    {
        "id": "create-availability",
        "title": "Creating Availability Templates",
        "videoLink": "",
        "markdownFile": "create-availability.md",
        "icon": "pi pi-plus"
    },
    {
        "id": "create-discount",
        "title": "Creating Discounts",
        "videoLink": "",
        "markdownFile": "create-discount.md",
        "icon": "pi pi-plus"
    },
    {
        "id": "create-product",
        "title": "Creating Products",
        "videoLink": "",
        "markdownFile": "create-product.md",
        "icon": "pi pi-plus"
    },
    {
        "id": "create-rule",
        "title": "Creating Rules",
        "videoLink": "",
        "markdownFile": "create-rules.md",
        "icon": "pi pi-plus"
    },
    {
        "id": "create-taxes",
        "title": "Creating Taxes",
        "videoLink": "",
        "markdownFile": "create-taxes.md",
        "icon": "pi pi-plus"
    },
    {
        "id": "create-transaction",
        "title": "Creating Transactions",
        "videoLink": "",
        "markdownFile": "create-transaction.md",
        "icon": "pi pi-plus"
    },
    {
        "id": "create-user",
        "title": "Creating Users",
        "videoLink": "",
        "markdownFile": "create-user.md",
        "icon": "pi pi-plus"
    },
    {
        "id": "create-note",
        "title": "Creating Notes",
        "videoLink": "",
        "markdownFile": "creating-note.md",
        "icon": "pi pi-plus"
    },
    {
        "id": "dashboard",
        "title": "The Dashboard",
        "videoLink": "",
        "markdownFile": "dashboard.md",
        "icon": "pi pi-home"
    },
    {
        "id": "delete-availability-template",
        "title": "Deleting Availability Templates",
        "videoLink": "",
        "markdownFile": "delete-availability-template.md",
        "icon": "pi pi-trash"
    },
    {
        "id": "delete-availability",
        "title": "Deleting Availability",
        "videoLink": "",
        "markdownFile": "delete-availability.md",
        "icon": "pi pi-trash"
    },
    {
        "id": "delete-discounts",
        "title": "Deleting Discounts",
        "videoLink": "",
        "markdownFile": "delete-discounts.md",
        "icon": "pi pi-trash"
    },
    {
        "id": "delete-prices",
        "title": "Deleting Prices",
        "videoLink": "",
        "markdownFile": "delete-prices.md",
        "icon": "pi pi-trash"
    },
    {
        "id": "delete-products",
        "title": "Deleing Products",
        "videoLink": "",
        "markdownFile": "delete-products.md",
        "icon": "pi pi-trash"
    },
    {
        "id": "delete-users",
        "title": "Deleting Users",
        "videoLink": "",
        "markdownFile": "delete-users.md",
        "icon": "pi pi-trash"
    },
    {
        "id": "discounts",
        "title": "Discounts",
        "videoLink": "",
        "markdownFile": "discounts.md",
        "icon": "pi pi-tag"
    },
    {
        "id": "edit-asset",
        "title": "Editing Assets",
        "videoLink": "",
        "markdownFile": "edit-asset.md",
        "icon": "pi pi-pencil"
    },
    {
        "id": "edit-availability",
        "title": "Editing Availability",
        "videoLink": "",
        "markdownFile": "edit-availability.md",
        "icon": "pi pi-pencil"
    },
    {
        "id": "edit-discounts",
        "title": "Editing Discounts",
        "videoLink": "",
        "markdownFile": "edit-discounts.md",
        "icon": "pi pi-pencil"
    },
    {
        "id": "edit-job",
        "title": "Editing a Job",
        "videoLink": "",
        "markdownFile": "edit-job.md",
        "icon": "pi pi-pencil"
    },
    {
        "id": "edit-prices",
        "title": "Editing Prices",
        "videoLink": "",
        "markdownFile": "edit-prices.md",
        "icon": "pi pi-pencil"
    },
    {
        "id": "edit-products",
        "title": "Editing Products",
        "videoLink": "",
        "markdownFile": "edit-products.md",
        "icon": "pi pi-pencil"
    },
    {
        "id": "edit-roles",
        "title": "Editing Roles",
        "videoLink": "",
        "markdownFile": "edit-roles.md",
        "icon": "pi pi-pencil"
    },
    {
        "id": "edit-schedule",
        "title": "Editing the Schedule",
        "videoLink": "",
        "markdownFile": "edit-schedule.md",
        "icon": "pi pi-pencil"
    },
    {
        "id": "edit-user",
        "title": "Editing a User",
        "videoLink": "",
        "markdownFile": "edit-user.md",
        "icon": "pi pi-pencil"
    },
    {
        "id": "estimating-booking",
        "title": "Estimating - Booking Screen",
        "videoLink": "",
        "markdownFile": "estimating-booking.md",
        "icon": "pi pi-money-bill"
    },
    {
        "id": "estimating-confirmation",
        "title": "Estimating - Confirmation Screen",
        "videoLink": "",
        "markdownFile": "estimating-confirmation.md",
        "icon": "pi pi-money-bill"
    },
    {
        "id": "estimating-customer-information",
        "title": "Estiamting - Customer Information Screen",
        "videoLink": "",
        "markdownFile": "estimating-customer-information.md",
        "icon": "pi pi-money-bill"
    },
    {
        "id": "estimating-inventory-yembo",
        "title": "Estimating - Inventory Screen",
        "videoLink": "",
        "markdownFile": "estimating-inventory-yembo.md",
        "icon": "pi pi-money-bill"
    },
    {
        "id": "estimating-inventory",
        "title": "Estimating - Inventory",
        "videoLink": "",
        "markdownFile": "estimating-inventory.md",
        "icon": "pi pi-money-bill"
    },
    {
        "id": "estimating-location",
        "title": "Estimating - Location Screen",
        "videoLink": "",
        "markdownFile": "estimating-location.md",
        "icon": "pi pi-money-bill"
    },
    {
        "id": "estimating-manual-address",
        "title": "Estimating - Adding an Address Manually",
        "videoLink": "",
        "markdownFile": "estimating-manual-address.md",
        "icon": "pi pi-money-bill"
    },
    {
        "id": "estimating-notes",
        "title": "Estimating - Adding Notes",
        "videoLink": "",
        "markdownFile": "estimating-notes.md",
        "icon": "pi pi-money-bill"
    },
    {
        "id": "estimating-products-and-services",
        "title": "Estimating - Products and Services",
        "videoLink": "",
        "markdownFile": "estimating-products-and-services.md",
        "icon": "pi pi-money-bill"
    },
    {
        "id": "business-units",
        "title": "Business Units",
        "videoLink": "",
        "markdownFile": "franchise-management.md",
        "icon": "pi pi-sitemap"
    },
    {
        "id": "business",
        "title": "Business",
        "videoLink": "",
        "markdownFile": "franchise.md",
        "icon": "pi pi-table"
    },
    {
        "id": "job-page",
        "title": "Job Page",
        "videoLink": "",
        "markdownFile": "job-page.md",
        "icon": "pi pi-file-o"
    },
    {
        "id": "jobs",
        "title": "Jobs",
        "videoLink": "",
        "markdownFile": "jobs.md",
        "icon": "pi pi-briefcase"
    },
    {
        "id": "navigation",
        "title": "Navigation",
        "videoLink": "",
        "markdownFile": "navigation.md",
        "icon": "pi pi-bars"
    },
    {
        "id": "products",
        "title": "Products",
        "videoLink": "",
        "markdownFile": "products.md",
        "icon": "pi pi-tag"
    },
    {
        "id": "rules",
        "title": "Rules",
        "videoLink": "",
        "markdownFile": "rules.md",
        "icon": "pi pi-info-circle"
    },
    {
        "id": "schedule",
        "title": "Schedule",
        "videoLink": "",
        "markdownFile": "schedule.md",
        "icon": "pi pi-calendar"
    }
]
